module.exports = __webpack_public_path__ + "static/media/02.Main Character.5a5959fc.jpg";